export default "__VITE_ASSET__BjZWmMKS__"